import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { AdminService } from '../services/admin.service';

export const canMatchGuard: CanMatchFn = (route, segments) => {
  const adminService = inject(AdminService);
  const role = adminService.getDecodedAccessToken()?.role;
  if(!route.data || !route.data['role'])
    return true;
  if (typeof window === 'undefined') return false;

  if(route.data['role'].includes(Number(role)))
    return true;
  else
    return false;
};
